<script lang="ts">
	import Container from '$lib/components/ui/container/container.svelte';
	import Separator from '$lib/components/ui/separator/separator.svelte';
	import { TwitterIcon } from 'lucide-svelte';
</script>

<footer class="mt-8 w-full px-4 sm:px-8" aria-labelledby="footer-heading">
	<h2 id="footer-heading" class="sr-only">Footer</h2>
	<Container class="mx-auto max-w-[1200px] gap-3">
		<div class="flex w-full flex-row items-center justify-center gap-4">
			<p class="max-w-5xl text-center text-sm text-lightQuaternary">
				Meeko.ai isn't endorsed by Riot Games and doesn't reflect the views or opinions of Riot
				Games or anyone officially involved in producing or managing Riot Games properties. Riot
				Games, and all associated properties are trademarks or registered trademarks of Riot Games,
				Inc.
			</p>
		</div>
		<div class="mt-8 flex w-full flex-row items-center justify-between gap-4">
			<enhanced:img
				loading="lazy"
				class="mb-2 h-5 w-auto"
				src="/static/images/meeko/meeko-text-logo.png"
				alt="meeko.ai"
			/>

			<div class="flex items-center space-x-4">
				<a
					href="https://discord.gg/GMYhTvBARG"
					target="_blank"
					class="text-lightTertiary hover:text-lightSecondary"
				>
					<span class="sr-only">Discord</span>
					<img class="h-6 w-6" src="/icons/discord.svg" alt="Discord icon" />
				</a>
			</div>
		</div>
		<Separator orientation="horizontal" />
		<div class="flex w-full flex-row items-center justify-between">
			<p class="text-xs leading-5 text-lightTertiary">
				&copy; 2024 Duoo GG AB. All rights reserved.
			</p>
			<div class="flex flex-row gap-2 font-light">
				<button
					class="text-xs text-lightTertiary hover:text-lightPrimary"
					type="button"
					data-cc="show-preferencesModal">Manage cookie preferences</button
				>
				<a href="/terms-and-conditions" class="text-xs text-lightTertiary hover:text-lightPrimary"
					>Terms & Conditions</a
				>
				<a href="/privacy-policy" class="text-xs text-lightTertiary hover:text-lightPrimary"
					>Privacy Policy</a
				>
			</div>
		</div>
	</Container>
</footer>
